// packages/ag-charts-locale/src/fr-FR.ts
var AG_CHARTS_LOCALE_FR_FR = {
  ariaAnnounceChart: "graphique, ${seriesCount}[number] s\xE9ries",
  ariaAnnounceFlowProportionLink: "lien ${index} de ${count}, de ${from} \xE0 ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "n\u0153ud ${index} de ${count}, ${description}",
  ariaAnnounceGaugeChart: "graphique en jauge, ${caption}",
  ariaAnnounceHierarchyChart: "graphique hi\xE9rarchique, ${caption}",
  ariaAnnounceHierarchyDatum: "niveau ${level}[number], ${count}[number] enfants, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Appuyez sur Espace ou Entr\xE9e pour basculer la visibilit\xE9",
  ariaLabelAddHorizontalLine: "Ajouter une ligne horizontale",
  ariaLabelAnnotationOptionsToolbar: "Options d'annotation",
  ariaLabelAnnotationSettingsDialog: "Param\xE8tres d'annotation",
  ariaLabelColorPicker: "S\xE9lecteur de couleur",
  ariaLabelFinancialCharts: "Graphiques financiers",
  ariaLabelLegend: "L\xE9gende",
  ariaLabelLegendItem: "${label}, \xC9l\xE9ment de l\xE9gende ${index}[number] sur ${count}[number]",
  ariaLabelLegendItemUnknown: "\xC9l\xE9ment de l\xE9gende inconnu",
  ariaLabelLegendPageNext: "Page de l\xE9gende suivante",
  ariaLabelLegendPagePrevious: "Page pr\xE9c\xE9dente de la l\xE9gende",
  ariaLabelLegendPagination: "Pagination des l\xE9gendes",
  ariaLabelNavigator: "Navigateur",
  ariaLabelNavigatorMaximum: "Maximum",
  ariaLabelNavigatorMinimum: "Minimum",
  ariaLabelNavigatorRange: "Plage",
  ariaLabelRangesToolbar: "Plages",
  ariaLabelSettingsTabBar: "Param\xE8tres",
  ariaLabelZoomToolbar: "Zoom",
  ariaValuePanRange: "${min}[percent0to2dp] \xE0 ${max}[percent0to2dp]",
  contextMenuDownload: "T\xE9l\xE9charger",
  contextMenuPanToCursor: "Panoramique jusqu'ici",
  contextMenuToggleOtherSeries: "Basculer les autres s\xE9ries",
  contextMenuToggleSeriesVisibility: "Basculer la visibilit\xE9",
  contextMenuZoomToCursor: "Zoomer ici",
  dialogHeaderChannel: "Canal",
  dialogHeaderDatePriceRange: "Date et prix",
  dialogHeaderDateRange: "Plage de dates",
  dialogHeaderFibonacciRange: "Retracement Fib",
  dialogHeaderLine: "Ligne",
  dialogHeaderPriceRange: "Plage de prix",
  dialogHeaderText: "Texte",
  dialogInputAlign: "Alignement",
  dialogInputColorPicker: "Couleur",
  dialogInputColorPickerAltText: "Couleur de texte",
  dialogInputExtendAbove: "\xC9tendre au-dessus",
  dialogInputExtendBelow: "\xC9tendre vers le bas",
  dialogInputExtendChannelEnd: "Prolonger la fin du canal",
  dialogInputExtendChannelStart: "\xC9tendre le d\xE9but du canal",
  dialogInputExtendLeft: "\xC9tendre \xE0 gauche",
  dialogInputExtendLineEnd: "\xC9tendre la fin de la ligne",
  dialogInputExtendLineStart: "\xC9tendre le d\xE9but de la ligne",
  dialogInputExtendRight: "\xC9tendre vers la droite",
  dialogInputFibonacciBands: "Bandes",
  dialogInputFibonacciBandsAltText: "Bandes de Fibonacci",
  dialogInputFillColorPicker: "Remplissage",
  dialogInputFillColorPickerAltText: "Couleur de remplissage",
  dialogInputFontSize: "Taille",
  dialogInputFontSizeAltText: "Taille de police",
  dialogInputLineStyle: "Tiret",
  dialogInputPosition: "Position",
  dialogInputReverse: "Inverser",
  dialogInputShowFill: "Afficher le remplissage",
  dialogInputStrokeWidth: "\xC9paisseur",
  dialogInputStrokeWidthAltText: "\xC9paisseur de la ligne",
  iconAltTextAlignCenter: "Centrer",
  iconAltTextAlignLeft: "Gauche",
  iconAltTextAlignRight: "Droite",
  iconAltTextClose: "Fermer",
  iconAltTextLineStyleDashed: "Longue-tirets",
  iconAltTextLineStyleDotted: "Tirets courts",
  iconAltTextLineStyleSolid: "Solide",
  iconAltTextPositionBottom: "Bas",
  iconAltTextPositionCenter: "Centre",
  iconAltTextPositionTop: "Haut",
  inputTextareaPlaceholder: "Ajouter du texte",
  measurerDateRangeBars: "${value}[number] barres",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Vol ${value}",
  overlayLoadingData: "Chargement des donn\xE9es...",
  overlayNoData: "Aucune donn\xE9e \xE0 afficher",
  overlayNoVisibleSeries: "Aucune s\xE9rie visible",
  overlayUnsupportedBrowser: "Version de navigateur incompatible. Veuillez mettre \xE0 jour votre navigateur.",
  seriesHistogramTooltipCount: "${yName} (compte)",
  seriesHistogramTooltipFrequency: "Fr\xE9quence",
  seriesHistogramTooltipMean: "${yName} (moyenne)",
  seriesHistogramTooltipSum: "${yName} (somme)",
  toolbarAnnotationsArrow: "Fl\xE8che",
  toolbarAnnotationsArrowDown: "Fl\xE8che Bas",
  toolbarAnnotationsArrowUp: "Fl\xE8che Haut",
  toolbarAnnotationsCallout: "Bulles",
  toolbarAnnotationsClearAll: "Tout Effacer",
  toolbarAnnotationsComment: "Commentaire",
  toolbarAnnotationsDatePriceRange: "Date et prix",
  toolbarAnnotationsDateRange: "Plage de dates",
  toolbarAnnotationsDelete: "Supprimer",
  toolbarAnnotationsDisjointChannel: "Canal disjoint",
  toolbarAnnotationsDragHandle: "Faites glisser la barre d'outils",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Retrait Fib",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib tendance bas\xE9e",
  toolbarAnnotationsFillColor: "Couleur de remplissage",
  toolbarAnnotationsHorizontalLine: "Ligne Horizontale",
  toolbarAnnotationsLineAnnotations: "Lignes de tendance",
  toolbarAnnotationsLineColor: "Couleur de la ligne",
  toolbarAnnotationsLineStrokeWidth: "\xC9paisseur du trait de la ligne",
  toolbarAnnotationsLineStyle: "Style de ligne",
  toolbarAnnotationsLock: "Verrouiller",
  toolbarAnnotationsMeasurerAnnotations: '"Mesureurs"',
  toolbarAnnotationsNote: "Note",
  toolbarAnnotationsParallelChannel: "Canal parall\xE8le",
  toolbarAnnotationsPriceRange: "Plage de prix",
  toolbarAnnotationsQuickDatePriceRange: "Mesurer",
  toolbarAnnotationsSettings: "Param\xE8tres",
  toolbarAnnotationsShapeAnnotations: "Fl\xE8ches",
  toolbarAnnotationsText: "Texte",
  toolbarAnnotationsTextAnnotations: "Annotations de texte",
  toolbarAnnotationsTextColor: "Couleur du texte",
  toolbarAnnotationsTextSize: "Taille du texte",
  toolbarAnnotationsTrendLine: "Tendance",
  toolbarAnnotationsUnlock: "D\xE9verrouiller",
  toolbarAnnotationsVerticalLine: "Ligne verticale",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 mois",
  toolbarRange1Year: "1A",
  toolbarRange1YearAria: "1 an",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 mois",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 mois",
  toolbarRangeAll: "Tous",
  toolbarRangeAllAria: "Tous",
  toolbarRangeYearToDate: "Depuis le d\xE9but de l'ann\xE9e",
  toolbarRangeYearToDateAria: "Ann\xE9e \xE0 ce jour",
  toolbarSeriesTypeCandles: "Bougies",
  toolbarSeriesTypeDropdown: "Type de graphique",
  toolbarSeriesTypeHighLow: "Haut Bas",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Bougies creuses",
  toolbarSeriesTypeLine: "Ligne",
  toolbarSeriesTypeLineWithMarkers: "Ligne avec Marqueurs",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Ligne en \xE9tapes",
  toolbarZoomPanEnd: "D\xE9placer jusqu'\xE0 la fin",
  toolbarZoomPanLeft: "D\xE9placer vers la gauche",
  toolbarZoomPanRight: "D\xE9placer vers la droite",
  toolbarZoomPanStart: "D\xE9placer au d\xE9but",
  toolbarZoomReset: "R\xE9initialiser le zoom",
  toolbarZoomZoomIn: "Agrandir",
  toolbarZoomZoomOut: "D\xE9zoomer",
  tooltipPaginationStatus: "${index}[number] sur ${count}[number]"
};
export {
  AG_CHARTS_LOCALE_FR_FR
};
//# sourceMappingURL=fr-FR.esm.mjs.map
